import { ReactNode } from 'react';

import { ModalDrawer } from '@ocx/ui-modals';

type ContactSupportLayoutProps = {
  children: ReactNode;
  isOpen: boolean;
  onClose(): void;
  onExited(): void;
};

export const ContactSupportLayout = (props: ContactSupportLayoutProps) => {
  const { children, isOpen, onClose, onExited } = props;
  return (
    <ModalDrawer minPaperHeight={280} open={isOpen} onClose={onClose} onExited={onExited}>
      {children}
    </ModalDrawer>
  );
};
